import React, { useEffect, useState } from 'react';
export function BookContent() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        setCurrentTestimonial(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
      }
    }, 5000); // Change testimonial every 5 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, [isPaused]);
  const testimonials = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/backAaSZ7SgUsovMLDg9uq/Generated_Image_October_13%2C_2025_-_8_59PM.png',
    name: 'Sarah M.',
    quote: "This book changed my perspective on what it means to be an American patriot. Charlie's journey is truly inspiring."
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oQXPWQsTTXBX7QbvLRodUC/Generated_Image_October_13%2C_2025_-_9_01PM.png',
    name: 'Michael T.',
    quote: 'A powerful read that reminds us all what conviction and courage can accomplish. Highly recommended.'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aF9GRETrKW4YdhDXEUq7dL/Generated_Image_October_13%2C_2025_-_9_00PM.png',
    name: 'Jennifer L.',
    quote: "Charlie's story is a testament to standing up for what you believe in. This book should be required reading."
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3PNwiXdFWNjVKDjMsypjWg/Generated_Image_October_13%2C_2025_-_9_02PM.png',
    name: 'Robert K.',
    quote: "As someone who values traditional American ideals, this book resonated deeply with me. Kirk's legacy lives on in these pages."
  }];
  const nextTestimonial = () => {
    setCurrentTestimonial(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
  };
  const prevTestimonial = () => {
    setCurrentTestimonial(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
  };
  return <section id="start-reading" className="py-16 bg-stone-50" data-id="element-10">
      <div className="max-w-3xl mx-auto px-6" data-id="element-11">
        <div className="bg-stone-100 p-8 md:p-12 shadow-lg rounded-sm border-t border-r border-stone-200" data-id="element-12">
          <div className="mb-8 text-center" data-id="element-13">
            <h2 className="text-2xl font-bold text-stone-800" data-id="element-14">Prologue</h2>
            <h3 className="text-xl text-stone-700 mt-2" data-id="element-15">
              The Man Behind the Microphone
            </h3>
            <div className="w-24 h-1 bg-amber-600 mx-auto mt-4" data-id="element-16"></div>
          </div>
          <div className="space-y-6 text-stone-800 leading-relaxed text-lg" data-id="element-17">
            <p className="first-letter:text-4xl first-letter:font-bold first-letter:text-amber-700 first-letter:mr-1 first-letter:float-left" data-id="element-18">
              There are men who ascend to power through elections, men who carve
              their names into marble by passing laws or wearing titles. Charlie
              Kirk was not one of them. He never won a seat in Congress, never
              collected degrees from elite universities, never wore the mantle
              of official power. His authority came from something more
              dangerous to the ruling class and more enduring to those who
              followed him: conviction. With nothing more than a microphone in
              his hand and faith burning in his chest, he walked into the storm
              of America's cultural wars and made himself impossible to ignore.
            </p>
            <p data-id="element-19">
              The America in which Charlie rose was an America trembling with
              contradictions. Universities that once prided themselves on free
              inquiry had grown hostile to dissenting thought. Young men and
              women, afraid of losing grades, friends, or future jobs, often
              kept their heads down. To question the reigning orthodoxy was to
              invite ridicule—or worse, silence. In a nation that prided itself
              on freedom of speech, the classroom had become one of the most
              dangerous places to speak freely. Into this atmosphere stepped a
              teenager with no diploma, no famous family, no establishment
              behind him. His only weapons were words and the courage to speak
              them.
            </p>
            <div className="py-4 px-6 border-l-4 border-amber-600 bg-amber-50 italic" data-id="element-20">
              <p className="text-amber-900" data-id="element-21">
                "His authority came from something more dangerous to the ruling
                class and more enduring to those who followed him: conviction."
              </p>
            </div>
            <p data-id="element-22">
              Charlie was sharp, relentless, and unapologetic. He saw what many
              feared to admit: that the battle for a nation's future would not
              be decided in the marble halls of Washington but in classrooms,
              cafeterias, and the shifting battlefield of digital media. He
              founded Turning Point USA at eighteen years old, a bold
              declaration that the youth of America were not a waiting line for
              tomorrow but a living force of today. From the moment he stood
              behind a table with stacks of flyers, the story of his life became
              inseparable from the story of a movement.
            </p>
            <p data-id="element-23">
              But to understand Charlie's rise, one must first understand the
              times that shaped him. His teenage years unfolded against the
              backdrop of America in turmoil. The September 11 attacks had
              shaken his generation into adulthood too early, reminding them
              that safety was fragile. The wars that followed in Iraq and
              Afghanistan split public opinion and sowed distrust in leaders.
              Then came the crash of 2008, when millions of families watched
              jobs vanish and savings evaporate. For many young Americans, the
              future no longer felt like promise—it felt like threat. A
              generation that should have inherited optimism instead inherited
              uncertainty, anxiety, and disillusion.
            </p>
            <div className="flex justify-center my-8" data-id="element-24">
              <div className="w-1/3 border-t-2 border-stone-300" data-id="element-25"></div>
            </div>
            <p data-id="element-26">
              Into this storm, the culture offered escape but not answers.
              Social media, still young, promised connection but often delivered
              isolation. Classrooms lectured about global citizenship while
              ignoring the roots of American identity. Celebrities mocked faith,
              and professors dismissed tradition. Young people were told they
              had power, yet when they tried to express dissenting views, they
              were silenced. This paradox defined the world that produced
              Charlie Kirk: a world where the loudest voices demanded tolerance,
              but only for certain opinions.
            </p>
            <p data-id="element-27">
              Charlie's defiance was not born in comfort—it was forged in this
              furnace of contradiction. His refusal to go to college was not
              merely a rejection of a personal path; it was a protest against a
              system that had betrayed its own promise of open inquiry. His
              boldness on campuses was not showmanship but survival, a refusal
              to let the voices of his peers be crushed under the weight of
              conformity. In him, his generation saw something they had long
              suspected but rarely witnessed: that courage was still possible.
            </p>
            <p data-id="element-28">
              His voice cut differently depending on who heard it. To his
              followers, it was a beacon—direct, uncompromising, the kind of
              voice that gave them permission to speak after years of being told
              to remain silent. To his critics, it was a provocation, an endless
              challenge to everything they held sacred. But no matter the
              reaction, there was one constant: Charlie Kirk was never
              invisible. In a nation flooded with talking heads, he had the rare
              ability to turn sound into echo, to make words linger long after
              the microphone was switched off.
            </p>
          </div>
          <div className="mt-10 flex justify-between items-center text-sm text-stone-500" data-id="element-29">
            <span data-id="element-30">Page 5-8</span>
            <span data-id="element-31">Prologue</span>
          </div>
        </div>
        {/* Testimonials Carousel */}
        <div className="mt-16 mb-8" data-id="element-32">
          <h2 className="text-2xl font-bold text-stone-800 text-center mb-8" data-id="element-33">
            Reader Testimonials
          </h2>
          <div className="bg-stone-100 p-8 rounded-sm shadow-lg border-t border-r border-stone-200" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-34">
            <div className="relative" data-id="element-35">
              <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-36">
                <div className="md:w-1/2 w-full aspect-square md:aspect-auto" data-id="element-37">
                  <img src={testimonials[currentTestimonial].image} alt={`${testimonials[currentTestimonial].name} with Voices of Freedom book`} className="w-full h-full object-cover rounded-md shadow-md aspect-square md:aspect-auto" data-id="element-38" />
                </div>
                <div className="md:w-1/2 text-center md:text-left" data-id="element-39">
                  <div className="text-amber-700 text-5xl font-serif mb-4" data-id="element-40">
                    "
                  </div>
                  <p className="text-stone-700 italic text-lg mb-4" data-id="element-41">
                    {testimonials[currentTestimonial].quote}
                  </p>
                  <div className="text-right text-amber-700 text-5xl font-serif" data-id="element-42">
                    "
                  </div>
                  <p className="text-stone-600 font-medium mt-4" data-id="element-43">
                    — {testimonials[currentTestimonial].name}
                  </p>
                </div>
              </div>
              <div className="flex justify-between mt-8" data-id="element-44">
                <button onClick={prevTestimonial} className="bg-stone-200 hover:bg-amber-600 hover:text-white text-stone-700 p-2 rounded-full transition duration-300" aria-label="Previous testimonial" data-id="element-45">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-46">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-47" />
                  </svg>
                </button>
                <div className="flex gap-2" data-id="element-48">
                  {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentTestimonial(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${currentTestimonial === index ? 'bg-amber-600 w-6' : 'bg-stone-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-49" />)}
                </div>
                <button onClick={nextTestimonial} className="bg-stone-200 hover:bg-amber-600 hover:text-white text-stone-700 p-2 rounded-full transition duration-300" aria-label="Next testimonial" data-id="element-50">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-51">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-52" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}